<template>
  <form @submit="submit">
    <h1>Quote: {{ data.formData.QuoteNumber }}</h1>
    <div class="card convert-to-order-form">
      <div class="card-header">
        <h3>{{ getContentItem("convertToOrder") }}</h3>
      </div>
      <div class="card-body">
        <p class="copy">
          {{ getContentItem("convertToOrderMessage") }}
        </p>
        <div class="form-group">
          <label for="poNumber">{{ getContentItem("poNumber") }}:</label>
          <b-form-input
            id="poNumber"
            v-model="poNumber"
            v-validate="{ required: true }"
            type="text"
            name="poNumber"
            class="form-control"
            :state="ValidateState('poNumber')"
            autofocus
          />
          <b-form-invalid-feedback>{{ getContentItem("poNumber") }} {{ getContentItem("isRequired") }}</b-form-invalid-feedback>
        </div>
        <div class="form-group">
          <label for="shippingMethod">{{ getContentItem("shipVia") }}:</label>
          <b-form-input
            id="shippingMethod"
            v-model="shippingMethod"
            v-validate="{ required: true }"
            type="text"
            name="shippingMethod"
            class="form-control"
            :state="ValidateState('shippingMethod')"
          />
          <b-form-invalid-feedback>{{ getContentItem("shipVia") }} {{ getContentItem("isRequired") }}</b-form-invalid-feedback>
        </div>
        <div class="form-group">
          <label for="emailNotes">{{ getContentItem("notesOrModifications") }}:</label>
          <b-form-textarea
            id="emailNotes"
            v-model="emailNotes"
            name="emailNotes"
            class="form-control"
            :state="ValidateState('emailNotes')"
          />
        </div>
      </div>
      <div class="card-footer text-center">
        <b-button
          type="submit"
          variant="primary"
          size="large"
          :class="[formIsValid ? '' : 'disabled', 'mr-2']"
          :disabled="!formIsValid || isBusy"
        >
          <loading-spinner v-if="isBusy" />
          {{ getContentItem("submit") }}
        </b-button>
        <b-button
          type="button"
          variant="dark"
          size="large"
          @click="cancel"
        >
          {{ getContentItem("cancel") }}
        </b-button>
      </div>
    </div>
  </form>
</template>

<script>
  import { mapGetters } from "vuex";

  import { inputValidateState } from "@/components/mixins/inputValidateState";

  import { ErrorLogService, QuoteService } from "@/services";

  import { LoadingSpinner } from "@/components/Elements";

  export default {
    name: "ConvertForm",
    components: {
      LoadingSpinner
    },
    mixins: [inputValidateState],
    computed: {
      ...mapGetters(["getContentItem"])
    },
    props: {
      data: {
        type: Object,
        required: true
      }
    },
    data: () => ({
      poNumber: "",
      shippingMethod: "",
      emailNotes: "",
      isBusy: false,
      formIsValid: {}
    }),
    updated() {
      this.$validator.validateAll().then(result => {
        this.formIsValid = result;
      });
    },
    methods: {
      submit: function(e) {
        e.preventDefault();

        this.isBusy = true;

        const formData = {
          ...this.data.formData,
          PoNumber: this.poNumber,
          ShippingMethod: this.shippingMethod,
          EmailNotes: this.emailNotes
        };

        QuoteService.submitQuote(this.data.params, formData)
          .then(() => {
            this.data.showThankYou();
          })
          .catch(error => {
            const errorMessage = ErrorLogService.LogAndGetErrorMessage(error);

            this.data.showSendFailure(errorMessage);
          })
          .finally(() => {
            this.isBusy = false;
          });
      },

      cancel: function(e) {
        e.preventDefault();
        this.data.hideForm();
      }
    }
  };
</script>
